import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { BaseService } from '@essent/common';
import { snakeCase, toHttpParams } from '@essent/common';
import { API_PREFIX } from '@core/config-angular';
import type { Observable } from 'rxjs';
import {
  type SolarPanelsNewCustomerAddressCheckRequestQuery,
  type SolarPanelsNewCustomerAddressCheckResponseV1,
} from '@innogy/feh/models';

@Injectable()
export class GetSolarPanelsAddressCheckService
  implements
    BaseService<
      SolarPanelsNewCustomerAddressCheckRequestQuery,
      SolarPanelsNewCustomerAddressCheckResponseV1
    >
{
  private readonly apiUrl: string | null = inject(API_PREFIX, {
    optional: true,
  });
  private readonly httpClient = inject(HttpClient);

  public readonly apiVersion = '1';
  public readonly endpoint = `${
    this.apiUrl || ''
  }/eplus/solarpanels/new-customer/address-check/v${this.apiVersion}`;

  public call$(
    payload: SolarPanelsNewCustomerAddressCheckRequestQuery
  ): Observable<SolarPanelsNewCustomerAddressCheckResponseV1> {
    const headers = { Accept: 'application/json' };
    const params = toHttpParams(snakeCase(payload));

    return this.httpClient.get<SolarPanelsNewCustomerAddressCheckResponseV1>(
      this.endpoint,
      { headers, params }
    );
  }
}
